// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sampleId: __t.u64().primaryKey().name("sample_id"),
  runKey: __t.string().name("run_key"),
  legKey: __t.string().name("leg_key"),
  t: __t.f32(),
  fps: __t.f32(),
  frameMsP50: __t.f32().name("frame_ms_p_50"),
  frameMsP95: __t.f32().name("frame_ms_p_95"),
  frameMsMax: __t.f32().name("frame_ms_max"),
  drawCalls: __t.u32().name("draw_calls"),
  triangles: __t.u64(),
  pipelines: __t.u32(),
  heapMb: __t.f32().name("heap_mb"),
  gpuMs: __t.f32().name("gpu_ms"),
  loaf: __t.u32(),
  x: __t.f64(),
  z: __t.f64(),
  censusJson: __t.string().name("census_json"),
  at: __t.timestamp(),
});
